import { QueryClient } from '@tanstack/react-query';
import Pubnub from 'pubnub';

import { handleMessageEvent } from './handleMessageEvent';
import { parseEvent } from './parseEvent';
import { PubNubMessageKey } from './types';

export const eventHandlerFactory =
  ({
    queryClient,
    roomName,
    isRosteredRoom,
    activityInstanceId,
    channels,
  }: {
    queryClient: QueryClient;
    roomName: string;
    isRosteredRoom: boolean;
    activityInstanceId: number;
    channels: string[];
  }) =>
  (pubnubMessageEvent: Pubnub.MessageEvent) => {
    if (!channels.includes(pubnubMessageEvent.channel)) {
      if (__DEV__) {
        console.debug(`ignoring message for room ${roomName}`);
      }
      return;
    }

    const message = parseEvent(pubnubMessageEvent.message);
    if (!message) {
      if (__DEV__) {
        console.debug(`Could not parse pubnubMessageEvent`);
        console.debug(pubnubMessageEvent);
      }
      return;
    }

    if (
      message?.key === PubNubMessageKey.StudentResponse &&
      activityInstanceId !== message.data.activity_instance
    ) {
      if (__DEV__) {
        console.debug(
          `skipping pubnub message with key of ${PubNubMessageKey.StudentResponse} since it is not for the current activity Instance.`
        );
        console.debug(`current activity ${activityInstanceId}`);
        console.debug(message);
      }
      return;
    }

    handleMessageEvent({
      queryClient: queryClient,
      message: message,
      isRosteredRoom: isRosteredRoom,
      activityInstanceId: activityInstanceId,
    });
  };
